import { assertNotEmpty } from '@festina-life/core'
import { type FormikProps, FormikSelect } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import { useFollowBranchCandidates } from '../../branchesPanel/branchDetails/manageBranch/useFollowBranchCandidates'
import type { BranchCreationInput } from '../types'
import { validate } from './helpers'

type Props = {
  state: FormikProps<BranchCreationInput>
}

export const FollowsBranchSelectionStep = ({ state: { values } }: Props) => {
  const translate = useTranslate()

  assertNotEmpty(values.server)

  const allowedFollowBranches = useFollowBranchCandidates({
    branchName: values.branchName,
    baseBranchName: values.baseBranch?.name,
    category: values.category,
    server: values.server,
  })

  return (
    <>
      <p>
        {translate(
          'branchCreationWizard.followsBranchSelectionStep.description',
        )}
      </p>
      <FormikSelect
        options={allowedFollowBranches}
        name={validate('followsBranch')}
        label={translate('branchCreationForm.followsBranch.label')}
        disabled={!allowedFollowBranches?.length}
        renderFn={(specification) => specification.name ?? ''}
        keyFn={(specification) => specification.name ?? ''}
      />
    </>
  )
}
